// extracted by mini-css-extract-plugin
export default {"notPartner":"Partner_notPartner__H7ZgV"};